module.exports = "https://web-assets.ifttt.com/packs/media/activity/check-c0a32e82.svg";